var $j = jQuery.noConflict();

$j(document).ready(function ($) {
    
        //testimonial form
        $('form[name="cineweb_user_rating"]').submit(function(event) {
                                        event.preventDefault();
                                        var form = $(this);

                                        if(form.find(':input').val() == 0) {
                                            growl_message($('#rating_missing').html());
                                        } else {
                                            $.ajax(form.attr('action'),
                                                    {
                                                        method : form.attr('method'),
                                                        data : form.serialize(),
                                                        success : function(transport) {
                                                                    var message = null;

                                                                    switch(transport.success) {
                                                                        case 1:
                                                                            message = $('#rating_ok').html();
                                                                            var submitButton = form.find('button#submit');
                                                                            submitButton.html(submitButton.data('text-modify') + ' <i class="hidden-xs icon-note"></i>');
                                                                            var yourReview = $('#your-review .comment-testimonial__content');
                                                                            if (yourReview && yourReview.length > 1) {
                                                                                console.log(yourReview);
                                                                                yourReview.html(form.find('#cineweb_user_rating_review').val());
                                                                                var yourReviewStars = $('#your-review .stars');
                                                                                var yourReviewInputId = $('#your-review .stars input').attr('id');
                                                                                yourReviewStars.html('<input id="'+yourReviewInputId+'" name="'+yourReviewInputId+'" value="'+form.find('#cineweb_user_rating_rating').val()+'" type="text">');
                                                                                $('#your-review .stars input').rating({
                                                                                    'min': 0,
                                                                                    'max': 5,
                                                                                    'size': 'xs',
                                                                                    'showClear': true,
                                                                                    'readonly': true,
                                                                                    'glyphicon': false,
                                                                                    'showCaption': false
                                                                                });
                                                                            } else {
                                                                                console.log('test');
                                                                                var mySwiper = new Swiper('.carousel-testimonials', {
                                                                                    direction: 'horizontal',
                                                                                    loop: false,
                                                                                    loopedSlides: null,
                                                                                    keyboard: true,
                                                                                    mousewheel: {
                                                                                        releaseOnEdges: true,
                                                                                    },
                                                                                    slidesPerColumn: 1,
                                                                                    spaceBetween: 10,
                                                                                    slidesOffsetBefore: 0,
                                                                                    slidesOffsetAfter: 0,
                                                                                    slidesPerView: 1,
                                                                                    breakpoints: {
                                                                                        // when window width is >= 468px
                                                                                        468: {
                                                                                            slidesPerView: 2,
                                                                                        },
                                                                                        // when window width is >= 992px
                                                                                        992: {
                                                                                            slidesPerView: 4,
                                                                                        }
                                                                                    },
                                                                                    navigation: {
                                                                                        nextEl: '.swiper-button-next',
                                                                                        prevEl: '.swiper-button-prev',
                                                                                        disabledClass: 'hidden',
                                                                                        hiddenClass: 'hidden',
                                                                                    },
                                                                                });
                                                                                mySwiper.addSlide(1, '<div class="swiper-slide">' + transport.html + '</div>');
                                                                                mySwiper.update();
                                                                                $('#your-review .stars input').rating({
                                                                                    'min': 0,
                                                                                    'max': 5,
                                                                                    'size': 'xs',
                                                                                    'showClear': true,
                                                                                    'readonly': true,
                                                                                    'glyphicon': false,
                                                                                    'showCaption': false
                                                                                });
                                                                            }
                                                                            break;
                                                                        case 0:
                                                                            message = $('#rating_nok').html();
                                                                            $('#submit').attr('disabled', true);
                                                                            break;
                                                                    }

                                                                    growl_message(message);
                                                                }
                                                    }
                                                );
                                        }
                                    }
                                );
              
        //like and dislike buttons
        $('.opinion-footer__nbr').click(function() {
                                            var button = $(this);
                                            $.ajax(button.attr('data-href'),
                                                    {
                                                        success : function(transport) {
                                                                    var message = null;
                                                                
                                                                    switch(transport.success) {
                                                                        case 1:
                                                                            var span = button.find('span');
                                                                            span.html(parseFloat(span.html()) + 1);
                                                                            message = $('#vote_ok').html();
                                                                            break;
                                                                        case 0:
                                                                            message = $('#vote_nok').html();
                                                                            button.attr('disabled', true);
                                                                            button.siblings().attr('disabled', true);
                                                                            break;
                                                                    }
                                                                    
                                                                    growl_message(message);
                                                                }
                                                    }
                                                );
                                        }   
                                    );
                   
        // abuse report button
        $('.opinion-delete a').click(function(event) {
                                        event.preventDefault();
                                        var link = $(this);
                                        if(link.attr('disabled') != "disabled") {
                                            $.ajax(link.attr('href'),
                                                    {
                                                        success : function(transport) {
                                                            var message = null;
                                                            
                                                            switch(transport.success) {
                                                                case 1:
                                                                    message = $('#abuse_ok').html();
                                                                    break;
                                                                case 0:
                                                                    message = $('#abuse_nok').html();
                                                                    link.attr('disabled', true);
                                                                    break;
                                                            }

                                                            growl_message(message);
                                                        }
                                                    }
                                                );
                                        }
                                    }   
                                );
            
        //rating stars
        $('.stars input.rating-stars').rating(
                            {
                                'showCaption' : true,
                                'starCaptions': function(val) {
                                                    return '(' + val + ')';
                                                },
                                'starCaptionClasses' : function(val) {
                                                    return ' ';
                                                },
                                'min' : 0,
                                'max' : 5,
                                'step' : 0.5,
                                'size' : 'xxs',
                                'stars' : 5,
                                'symbol' : '\ue620',
                                'clearCaption' : ''
                            }
                        );

    }
);

